(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[492],{

/***/ 1127:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blog/[slug]",
      function () {
        return __webpack_require__(1185);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 1185:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ BlogDetail; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/react-query/es/index.js
var es = __webpack_require__(8767);
// EXTERNAL MODULE: ./src/@shared/service/cms-api.ts + 1 modules
var cms_api = __webpack_require__(7746);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Container.js
var Container = __webpack_require__(682);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Row.js
var Row = __webpack_require__(4051);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Col.js
var Col = __webpack_require__(1555);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(5675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./src/@shared/functions/dateFormat.ts
var dateFormat = __webpack_require__(9847);
;// CONCATENATED MODULE: ./node_modules/react-share/es/utils/assert.js
var __extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var AssertionError = /** @class */ (function (_super) {
    __extends(AssertionError, _super);
    function AssertionError(message) {
        var _this = _super.call(this, message) || this;
        _this.name = 'AssertionError';
        return _this;
    }
    return AssertionError;
}(Error));
function assert(value, message) {
    if (!value) {
        throw new AssertionError(message);
    }
}

;// CONCATENATED MODULE: ./node_modules/react-share/es/utils/objectToGetParams.js
function objectToGetParams(object) {
    var params = Object.entries(object)
        .filter(function (_a) {
        var value = _a[1];
        return value !== undefined && value !== null;
    })
        .map(function (_a) {
        var key = _a[0], value = _a[1];
        return "".concat(encodeURIComponent(key), "=").concat(encodeURIComponent(String(value)));
    });
    return params.length > 0 ? "?".concat(params.join('&')) : '';
}

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(4184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
;// CONCATENATED MODULE: ./node_modules/react-share/es/ShareButton.js
var ShareButton_extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (undefined && undefined.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (undefined && undefined.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (undefined && undefined.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};


var isPromise = function (obj) {
    return !!obj && (typeof obj === 'object' || typeof obj === 'function') && typeof obj.then === 'function';
};
var getBoxPositionOnWindowCenter = function (width, height) { return ({
    left: window.outerWidth / 2 + (window.screenX || window.screenLeft || 0) - width / 2,
    top: window.outerHeight / 2 + (window.screenY || window.screenTop || 0) - height / 2,
}); };
var getBoxPositionOnScreenCenter = function (width, height) { return ({
    top: (window.screen.height - height) / 2,
    left: (window.screen.width - width) / 2,
}); };
function windowOpen(url, _a, onClose) {
    var height = _a.height, width = _a.width, configRest = __rest(_a, ["height", "width"]);
    var config = __assign({ height: height, width: width, location: 'no', toolbar: 'no', status: 'no', directories: 'no', menubar: 'no', scrollbars: 'yes', resizable: 'no', centerscreen: 'yes', chrome: 'yes' }, configRest);
    var shareDialog = window.open(url, '', Object.keys(config)
        .map(function (key) { return "".concat(key, "=").concat(config[key]); })
        .join(', '));
    if (onClose) {
        var interval_1 = window.setInterval(function () {
            try {
                if (shareDialog === null || shareDialog.closed) {
                    window.clearInterval(interval_1);
                    onClose(shareDialog);
                }
            }
            catch (e) {
                /* eslint-disable no-console */
                console.error(e);
                /* eslint-enable no-console */
            }
        }, 1000);
    }
    return shareDialog;
}
var ShareButton = /** @class */ (function (_super) {
    ShareButton_extends(ShareButton, _super);
    function ShareButton() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.openShareDialog = function (link) {
            var _a = _this.props, onShareWindowClose = _a.onShareWindowClose, _b = _a.windowHeight, windowHeight = _b === void 0 ? 400 : _b, _c = _a.windowPosition, windowPosition = _c === void 0 ? 'windowCenter' : _c, _d = _a.windowWidth, windowWidth = _d === void 0 ? 550 : _d;
            var windowConfig = __assign({ height: windowHeight, width: windowWidth }, (windowPosition === 'windowCenter'
                ? getBoxPositionOnWindowCenter(windowWidth, windowHeight)
                : getBoxPositionOnScreenCenter(windowWidth, windowHeight)));
            windowOpen(link, windowConfig, onShareWindowClose);
        };
        _this.handleClick = function (event) { return __awaiter(_this, void 0, void 0, function () {
            var _a, beforeOnClick, disabled, networkLink, onClick, url, openShareDialogOnClick, opts, link, returnVal;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = this.props, beforeOnClick = _a.beforeOnClick, disabled = _a.disabled, networkLink = _a.networkLink, onClick = _a.onClick, url = _a.url, openShareDialogOnClick = _a.openShareDialogOnClick, opts = _a.opts;
                        link = networkLink(url, opts);
                        if (disabled) {
                            return [2 /*return*/];
                        }
                        event.preventDefault();
                        if (!beforeOnClick) return [3 /*break*/, 2];
                        returnVal = beforeOnClick();
                        if (!isPromise(returnVal)) return [3 /*break*/, 2];
                        return [4 /*yield*/, returnVal];
                    case 1:
                        _b.sent();
                        _b.label = 2;
                    case 2:
                        if (openShareDialogOnClick) {
                            this.openShareDialog(link);
                        }
                        if (onClick) {
                            onClick(event, link);
                        }
                        return [2 /*return*/];
                }
            });
        }); };
        return _this;
    }
    ShareButton.prototype.render = function () {
        var _a = this.props, beforeOnClick = _a.beforeOnClick, children = _a.children, className = _a.className, disabled = _a.disabled, disabledStyle = _a.disabledStyle, forwardedRef = _a.forwardedRef, networkLink = _a.networkLink, networkName = _a.networkName, onShareWindowClose = _a.onShareWindowClose, openShareDialogOnClick = _a.openShareDialogOnClick, opts = _a.opts, resetButtonStyle = _a.resetButtonStyle, style = _a.style, url = _a.url, windowHeight = _a.windowHeight, windowPosition = _a.windowPosition, windowWidth = _a.windowWidth, rest = __rest(_a, ["beforeOnClick", "children", "className", "disabled", "disabledStyle", "forwardedRef", "networkLink", "networkName", "onShareWindowClose", "openShareDialogOnClick", "opts", "resetButtonStyle", "style", "url", "windowHeight", "windowPosition", "windowWidth"]);
        var newClassName = classnames_default()('react-share__ShareButton', {
            'react-share__ShareButton--disabled': !!disabled,
            disabled: !!disabled,
        }, className);
        var newStyle = resetButtonStyle
            ? __assign(__assign({ backgroundColor: 'transparent', border: 'none', padding: 0, font: 'inherit', color: 'inherit', cursor: 'pointer' }, style), (disabled && disabledStyle)) : __assign(__assign({}, style), (disabled && disabledStyle));
        return (react.createElement("button", __assign({}, rest, { "aria-label": rest['aria-label'] || networkName, className: newClassName, onClick: this.handleClick, ref: forwardedRef, style: newStyle }), children));
    };
    ShareButton.defaultProps = {
        disabledStyle: { opacity: 0.6 },
        openShareDialogOnClick: true,
        resetButtonStyle: true,
    };
    return ShareButton;
}(react.Component));
/* harmony default export */ var es_ShareButton = (ShareButton);

;// CONCATENATED MODULE: ./node_modules/react-share/es/hocs/createShareButton.js
var createShareButton_assign = (undefined && undefined.__assign) || function () {
    createShareButton_assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return createShareButton_assign.apply(this, arguments);
};


function createShareButton(networkName, link, optsMap, defaultProps) {
    function CreatedButton(props, ref) {
        var opts = optsMap(props);
        var passedProps = createShareButton_assign({}, props);
        // remove keys from passed props that are passed as opts
        var optsKeys = Object.keys(opts);
        optsKeys.forEach(function (key) {
            delete passedProps[key];
        });
        return (react.createElement(es_ShareButton, createShareButton_assign({}, defaultProps, passedProps, { forwardedRef: ref, networkName: networkName, networkLink: link, opts: optsMap(props) })));
    }
    CreatedButton.displayName = "ShareButton-".concat(networkName);
    return (0,react.forwardRef)(CreatedButton);
}
/* harmony default export */ var hocs_createShareButton = (createShareButton);

;// CONCATENATED MODULE: ./node_modules/react-share/es/FacebookShareButton.js



function facebookLink(url, _a) {
    var quote = _a.quote, hashtag = _a.hashtag;
    assert(url, 'facebook.url');
    return ('https://www.facebook.com/sharer/sharer.php' +
        objectToGetParams({
            u: url,
            quote: quote,
            hashtag: hashtag,
        }));
}
var FacebookShareButton = hocs_createShareButton('facebook', facebookLink, function (props) { return ({
    quote: props.quote,
    hashtag: props.hashtag,
}); }, {
    windowWidth: 550,
    windowHeight: 400,
});
/* harmony default export */ var es_FacebookShareButton = (FacebookShareButton);

;// CONCATENATED MODULE: ./node_modules/react-share/es/TwitterShareButton.js



function twitterLink(url, _a) {
    var title = _a.title, via = _a.via, _b = _a.hashtags, hashtags = _b === void 0 ? [] : _b, _c = _a.related, related = _c === void 0 ? [] : _c;
    assert(url, 'twitter.url');
    assert(Array.isArray(hashtags), 'twitter.hashtags is not an array');
    assert(Array.isArray(related), 'twitter.related is not an array');
    return ('https://twitter.com/share' +
        objectToGetParams({
            url: url,
            text: title,
            via: via,
            hashtags: hashtags.length > 0 ? hashtags.join(',') : undefined,
            related: related.length > 0 ? related.join(',') : undefined,
        }));
}
var TwitterShareButton = hocs_createShareButton('twitter', twitterLink, function (props) { return ({
    hashtags: props.hashtags,
    title: props.title,
    via: props.via,
    related: props.related,
}); }, {
    windowWidth: 550,
    windowHeight: 400,
});
/* harmony default export */ var es_TwitterShareButton = (TwitterShareButton);

;// CONCATENATED MODULE: ./node_modules/react-share/es/LinkedinShareButton.js



function linkedinLink(url, _a) {
    var title = _a.title, summary = _a.summary, source = _a.source;
    assert(url, 'linkedin.url');
    return ('https://linkedin.com/shareArticle' +
        objectToGetParams({ url: url, mini: 'true', title: title, summary: summary, source: source }));
}
var LinkedinShareButton = hocs_createShareButton('linkedin', linkedinLink, function (_a) {
    var title = _a.title, summary = _a.summary, source = _a.source;
    return ({ title: title, summary: summary, source: source });
}, {
    windowWidth: 750,
    windowHeight: 600,
});
/* harmony default export */ var es_LinkedinShareButton = (LinkedinShareButton);

;// CONCATENATED MODULE: ./src/assets/icons/share-icon-facebook.svg
/* harmony default export */ var share_icon_facebook = ({"src":"/_next/static/media/share-icon-facebook.828afc81.svg","height":26,"width":26});
;// CONCATENATED MODULE: ./src/assets/icons/share-icon-linkedin.svg
/* harmony default export */ var share_icon_linkedin = ({"src":"/_next/static/media/share-icon-linkedin.39997b2c.svg","height":27,"width":27});
;// CONCATENATED MODULE: ./src/assets/icons/share-icon-twitter.svg
/* harmony default export */ var share_icon_twitter = ({"src":"/_next/static/media/share-icon-twitter.59d828c8.svg","height":26,"width":27});
// EXTERNAL MODULE: ./src/@shared/functions/format.ts
var format = __webpack_require__(7814);
// EXTERNAL MODULE: ./src/@shared/components/icon/index.tsx + 3 modules
var icon = __webpack_require__(8068);
// EXTERNAL MODULE: ./src/@shared/hooks/framerMotion.tsx
var framerMotion = __webpack_require__(658);
// EXTERNAL MODULE: ./src/modules/blog/components/BlogDetailPost/BlogDetailPost.module.scss
var BlogDetailPost_module = __webpack_require__(4778);
var BlogDetailPost_module_default = /*#__PURE__*/__webpack_require__.n(BlogDetailPost_module);
;// CONCATENATED MODULE: ./src/modules/blog/components/BlogDetailPost/BlogDetailPost.tsx












const baseUrl = "https://www.casperlabs.io/";
function BlogDetailPost(param) {
    let { post  } = param;
    var ref, ref1;
    const formattedDate = (0,dateFormat/* default */.Z)(post.timePublished);
    const currentUrl = "".concat(baseUrl.substring(0, baseUrl.length - 1), "/blog/").concat(post.meta.slug);
    var _categoryName, _preview, _name, _description, _headerUrl, _body;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
        className: "blogDetailPost pt-0",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (BlogDetailPost_module_default()).containerBg,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Row/* default */.Z, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Col/* default */.Z, {
                            lg: {
                                span: 8,
                                offset: 2
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: (BlogDetailPost_module_default()).halfTitleContainer,
                                    children: [
                                        post.categoryName && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            className: " ".concat((BlogDetailPost_module_default()).halfTitleCategory),
                                            children: (_categoryName = post.categoryName) !== null && _categoryName !== void 0 ? _categoryName : ""
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            children: formattedDate
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                    className: "mb-5",
                                    children: post.title
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                                    className: "pb-2",
                                    dangerouslySetInnerHTML: {
                                        __html: (_preview = post.preview) !== null && _preview !== void 0 ? _preview : ""
                                    }
                                }),
                                post.author && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "d-flex gap-4 mb-5 align-items-center",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                            className: (BlogDetailPost_module_default()).authorImg,
                                            src: (0,format/* getCMSImage */.K)((ref = post.author) === null || ref === void 0 ? void 0 : ref.imageUrl),
                                            alt: (ref1 = post.author) === null || ref1 === void 0 ? void 0 : ref1.name,
                                            height: 80,
                                            width: 80
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "d-flex flex-column ".concat((BlogDetailPost_module_default()).authorInfo),
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                    className: "mb-2 ".concat((BlogDetailPost_module_default()).authorName),
                                                    children: (_name = post.author.name) !== null && _name !== void 0 ? _name : ""
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                    className: "mb-0",
                                                    children: post.author.title
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row/* default */.Z, {
                    className: "mb-5 pt-3 align-items-center ".concat((BlogDetailPost_module_default()).imgHeader),
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Col/* default */.Z, {
                            sm: 1,
                            lg: 2,
                            className: (BlogDetailPost_module_default()).socialSharingContainer,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(es_FacebookShareButton, {
                                    url: currentUrl,
                                    quote: post.title,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icon/* default */.Z, {
                                        source: share_icon_facebook.src
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(es_TwitterShareButton, {
                                    url: currentUrl,
                                    title: post.title,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icon/* default */.Z, {
                                        source: share_icon_twitter.src
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(es_LinkedinShareButton, {
                                    url: currentUrl,
                                    title: post.title,
                                    summary: (_description = post.meta.description) !== null && _description !== void 0 ? _description : "",
                                    source: "Casper Labs",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icon/* default */.Z, {
                                        source: share_icon_linkedin.src
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                            sm: 11,
                            lg: 10,
                            className: (BlogDetailPost_module_default()).imgContainer,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                src: (0,format/* getCMSImage */.K)((_headerUrl = post.headerUrl) !== null && _headerUrl !== void 0 ? _headerUrl : post.thumbnailUrl),
                                alt: post.title,
                                className: "position-relative",
                                fill: true
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(framerMotion/* default */.Z, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row/* default */.Z, {
                        className: "mt-5 align-items-center ".concat((BlogDetailPost_module_default()).postBody),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                                sm: 1,
                                lg: 2,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {})
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Col/* default */.Z, {
                                sm: 11,
                                lg: 8,
                                className: (BlogDetailPost_module_default()).mobilePaddingX,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "body",
                                        dangerouslySetInnerHTML: {
                                            __html: (_body = post.body) !== null && _body !== void 0 ? _body : ""
                                        }
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("hr", {
                                        className: "lineBodyEnd"
                                    })
                                ]
                            })
                        ]
                    })
                })
            })
        ]
    });
}

// EXTERNAL MODULE: ./src/@shared/components/head/customHead/customHead.tsx
var customHead = __webpack_require__(3065);
// EXTERNAL MODULE: ./src/@shared/components/newsletter/Newsletter2/Newsletter2.tsx + 1 modules
var Newsletter2 = __webpack_require__(7654);
// EXTERNAL MODULE: ./src/@shared/components/blog/BlogHorizontal/BlogHorizontal.tsx
var BlogHorizontal = __webpack_require__(2296);
;// CONCATENATED MODULE: ./src/pages/blog/[slug].tsx









const initialCatArgs = {
    sort: "timeCreated",
    limit: 0,
    parent: "Blog"
};
var __N_SSP = true;
function BlogDetail(param) {
    let { slug  } = param;
    const { data  } = (0,es.useQuery)([
        "blog-detail",
        slug
    ], ()=>(0,cms_api/* getPostPage */.M)({
            slug
        }, initialCatArgs));
    const detail = data;
    var _description, _imageUrl;
    const og = {
        ogTitle: detail.meta.title,
        ogDescription: (_description = detail.meta.description) !== null && _description !== void 0 ? _description : "",
        ogImage: (_imageUrl = detail.meta.imageUrl) !== null && _imageUrl !== void 0 ? _imageUrl : detail.headerUrl
    };
    const pageClass = "blogDetailPage";
    var _description1;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: pageClass,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(customHead/* default */.Z, {
                title: detail.meta.title,
                description: (_description1 = detail.meta.description) !== null && _description1 !== void 0 ? _description1 : "Content Description",
                og: og
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(framerMotion/* default */.Z, {
                animation: "fadeIn",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("main", {
                    children: [
                        data && /*#__PURE__*/ (0,jsx_runtime.jsx)(BlogDetailPost, {
                            post: data
                        }),
                        (data === null || data === void 0 ? void 0 : data.associationsData.blog) && (data === null || data === void 0 ? void 0 : data.associationsData.blog.length) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(framerMotion/* default */.Z, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                                className: "relatedPosts",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container/* default */.Z, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h5", {
                                            children: "Related Post"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(BlogHorizontal/* default */.Z, {
                                            list: data === null || data === void 0 ? void 0 : data.associationsData.blog,
                                            isLoading: false,
                                            hasNextPage: false,
                                            withoutFeatured: true,
                                            date: true
                                        })
                                    ]
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(framerMotion/* default */.Z, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Newsletter2/* default */.Z, {
                                col1: 5,
                                col2: 7,
                                title: "Sign up for our newsletter!"
                            })
                        })
                    ]
                })
            })
        ]
    });
}


/***/ }),

/***/ 4778:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"halfTitleContainer":"BlogDetailPost_halfTitleContainer__3K_b8","halfTitleCategory":"BlogDetailPost_halfTitleCategory__LJt1J","containerBg":"BlogDetailPost_containerBg__mh5dj","imgHeader":"BlogDetailPost_imgHeader__yBXUq","imgContainer":"BlogDetailPost_imgContainer__3RVK7","postBody":"BlogDetailPost_postBody__HrtR4","socialSharingContainer":"BlogDetailPost_socialSharingContainer__qX3ZT","authorImg":"BlogDetailPost_authorImg__93yA1","authorInfo":"BlogDetailPost_authorInfo__BGSfD","authorName":"BlogDetailPost_authorName___3oiT"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [437,675,182,726,774,888,179], function() { return __webpack_exec__(1127); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);